export default "__VITE_ASSET__db953b66__"